import React, { memo } from "react"
import aramex from "../../assets/ShippingCompaniesIcons/aramex.svg"
import dhl from "../../assets/ShippingCompaniesIcons/dhl.svg"
import elite from "../../assets/ShippingCompaniesIcons/elite.svg"
import fedex from "../../assets/ShippingCompaniesIcons/fedex.svg"
import shopini from "../../assets/ShippingCompaniesIcons/shopini-economy.svg"
import thabit from "../../assets/ShippingCompaniesIcons/thabit.svg"
import ups from "../../assets/ShippingCompaniesIcons/ups.svg"
import usps from "../../assets/ShippingCompaniesIcons/usps.svg"

const Card = ({
    logo,
    name,
    companyChange,
    companyId
}: {
    logo: string
    name: string
    companyChange: any
    companyId: string
}) => {
    let imageSrc = logo
    if (name.toLowerCase().match("aramex") || name.toLowerCase().match("aramex hk-ch")) imageSrc = aramex
    if (name.toLowerCase().match("dhl")) imageSrc = dhl
    if (name.toLowerCase().match("fedex") || name.match("INTERNATIONAL_PRIORITY")) imageSrc = fedex
    if (name.toLowerCase().match("usps")) imageSrc = usps
    if (name.toLowerCase().match("ups")) imageSrc = ups
    if (name.toLowerCase().match("shopini")) imageSrc = shopini
    if (name.toLowerCase().match("elite")) imageSrc = elite
    if (name.toLowerCase().match("thabit")) imageSrc = thabit

    return (
        <div className="card p-4" onClick={() => companyChange(companyId)}>
            <img src={imageSrc} className="shipping_logo" alt={name} />
        </div>
    )
}

export default memo(Card)
